import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import HomeHeader from '../../components/homeHeader/index.vue'
import UserService from '../../services/UserService'
import { showErrorToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  name: 'ActionsTab',
  data () {
    return {
      email: ''
    }
  },
  components: {
    HomeHeader
  },
  mounted () {
    // window.analytics.page('ForgotPassword')
    window.analytics.identify('ForgotPassword', {
      path: '/forgotPassword'
    })
  },
  computed: {},
  methods: {
    async forgotPass () {
      if (!this.email || !this.email.length || !this.validateEmail()) {
        this.error = 'Invalid email passed.'
        showErrorToast(this, this.error)
        return
      }
      const verifyToken = await UserService.requestVerify(this.email)
      // console.log(verifyToken)
      // if (!verifyToken) {
      //   return showErrorToast(this, 'Invalid email')
      // }
      if (verifyToken) {
        this.$router.push({ name: 'EnterOtp', params: { email: this.email } })
      } else {
        this.error = 'Invalid email.'
        showErrorToast(this, this.error)
      }
    },
    validateEmail () {
      return /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/.test(this.email)
    }
  }
}
